module.exports = __webpack_public_path__ + "295cc5ee99deef956330ab953365c12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default-img.png
// module id = 304
// module chunks = 61